(function ($, Drupal) {
  /**
   * Control hero title video size on resize.
   */
  Drupal.behaviors.bubbles = {
    attach: function (context, settings) {

      Drupal.kinaxisBubblesSettings = {
        'x': '0px',
        'blur': '13px',
        'spread': '-10px',
        'colour': 'rgba(0, 0, 0, 0.5)'
      };
      Drupal.kinaxisBubblesParallax = function() {
        var shadow = $('.paragraph--type--bubble-item .bubble');
        var line = $('.paragraph--type--bubbles .bubbles-container > .field');

        // Disable parallax box shadow for mobile.
        if (window.matchMedia('(max-width: 991px)').matches) {
          shadow.each(function() {
            $(this).css('box-shadow', '');
          });
          return;
        }

        shadow.each(function() {
          var self = $(this),
              parentHeight = $(window).height(),
              scrollHeight = $(window).scrollTop(),
              elementPosition = self.offset().top + self.height() / 2,
              viewportMiddle = scrollHeight + parentHeight / 2,
              shadowOffset = viewportMiddle - elementPosition,
              modifier = 10,
              offset = (shadowOffset / modifier);
          self.css('box-shadow', Drupal.kinaxisBubblesShadow(offset));
        });

        line.each(function() {
          var self = $(this),
            parentHeight = $(window).height(),
            scrollHeight = $(window).scrollTop(),
            modifier = 0.06,
            offset = (scrollHeight - parentHeight) * modifier;
          if (typeof self.data('pos-initial') == 'undefined') {
            self.data('pos-initial', parseInt(self.css('background-position-y')));
          }
          self.css('background-position-y', (self.data('pos-initial') + offset) + 'px');
        });
      };
      Drupal.kinaxisBubblesShadow = function(offset) {
        return Drupal.kinaxisBubblesSettings.x + ' '
                + offset + 'px '
                + Drupal.kinaxisBubblesSettings.blur + ' '
                + Drupal.kinaxisBubblesSettings.spread + ' '
                + Drupal.kinaxisBubblesSettings.colour;
      };

      $(once('kinaxisBubbles', 'body')).each(function () {  
        $(window).on('load scroll resize', function() {
          Drupal.kinaxisBubblesParallax();
        });
      });
    }
  }
})(jQuery, Drupal);